const state = {
  loading: false,
  success: false,
  error: false,
  price_plan_list: [],
  pricePlanEdit: {},
};

export default state;
